import { render, staticRenderFns } from "./ModalResendPrescription.vue?vue&type=template&id=0e95960e&scoped=true&lang=pug"
import script from "./ModalResendPrescription.vue?vue&type=script&lang=js"
export * from "./ModalResendPrescription.vue?vue&type=script&lang=js"
import style0 from "./ModalResendPrescription.vue?vue&type=style&index=0&id=0e95960e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e95960e",
  null
  
)

export default component.exports